<template>
  <gj-modal
    size="normal"
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>编辑标签</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="74px">
        <el-form-item
          label="标签名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请输入标签名称',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <gj-input v-model="form.name" width="100%"></gj-input>
        </el-form-item>
        <el-form-item
          label="标签分类"
          prop="parentId"
          :rules="[
            {
              required: true,
              message: '请选择上级分类',
              trigger: ['blur'],
            },
          ]"
        >
          <gj-tree-select
            v-model="form.parentId"
            :data="treeData"
            :clearable="false"
            :expandOnClickNode="true"
            width="100%"
          ></gj-tree-select>
        </el-form-item>

        <!-- <el-form-item
          label="状态"
          prop="state"
          :rules="[
            {
              required: true,
              message: '请选择状态',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-radio-group v-model="form.state">
            <el-radio
              v-for="item in StatusEnum.options"
              :key="item.id"
              :label="item.id"
            >
              {{ item.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="标签备注" prop="desc" style="margin-bottom: 0">
          <gj-textarea
            v-model="form.memo"
            :styles="{ height: '120px', width: '100%' }"
          >
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  formRuleMixin,
  responseMixin,
} from "../../../../../minxins";
import { StatusEnum } from "../common/enum";
import { tagUpdate, getTagTreeList } from "../../../../../api/system";

export default {
  name: "app-tag-edit-modal",
  mixins: [modalMixIn, formRuleMixin, responseMixin],
  props: {
    tag: {
      required: true,
    },
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        name: null,
        state: null,
        memo: null,
        parentId:null,
        id:null,
      },
      treeData: [],
      StatusEnum: StatusEnum,
    };
  },
  created() {
    this.queryData();
    this.form.name = this.tag.name;
    this.form.parentId = this.tag.fid;
    this.form.memo = this.tag.memo;
    this.form.state = this.tag.state;
    this.form.id=this.tag.id;
  },
  methods: {
    queryData() {
      this.loading = true;
      getTagTreeList()
        .then((res) => {
          this.treeData = res.data;
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
        this.confirmLoading = true;
        const params = {
          fid:this.form.parentId,
          id: this.form.id,
          name: this.form.name,
          memo: this.form.memo,
        };
        tagUpdate(params)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("编辑标签成功");
              this.$emit("created");
              this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
